<template>
  <div>
    <CoolLightBox :items="items" :index="index" loop @close="index = null">
    </CoolLightBox>
    <!-- gallery_area_start -->
    <div
      v-if="
        this.$router.history.current['path'] == '/en/gallery' ||
        this.$router.history.current['path'] == '/fr/gallery' ||
        this.$router.history.current['path'] == '/gallery'
      "
      
      style="padding-bottom: 2px"
      class="bradcam_area breadcam_bg about_bg_1 overlay2"
    >
      <div class="section_title2 text-center mb-90">
        <i style="color: #ffff" class="flaticon-scissors"></i>
        <h3 style="color: #ffff; font-size: 60px">{{ $t("gallery.title") }}</h3>
      </div>
    </div>
      

    <div class="gallery_area">
      <div class="container">
        <div class="row">
          <div class="col-xl-12"></div>
        </div>
        <div class="row">
          <div  
            v-if="this.$router.history.current['path'] == '/en' ||
            this.$router.history.current['path'] == '/fr' ||
            this.$router.history.current['path'] == '/'"
             class="col-xl-12">
            <div data-aos="fade-up" class="section_title2 text-center mb-90">
              <i class="flaticon-scissors"></i>
              <h3>{{ $t("gallery.title") }}</h3>
            </div>
          </div>
          
          <div
            data-aos="fade-up"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
            class="col-xl-12"
          >
            <carousel
              v-if="!isLoading"
              class="gallery_active owl-carousel owl-loaded owl-drag"
              :items="myOptions.items"
              :navText="myOptions.navText"
              :autoplaySpeed="myOptions.autoplaySpeed"
              :nav="myOptions.nav"
              :autoplayHoverPause="myOptions.autoplayHoverPause"
              :autoplay="myOptions.autoplay"
              :dots="myOptions.dots"
              :margin="myOptions.margin"
              :responsive="myOptions.responsive"
              :loop="myOptions.loop"
            >
              <div
                class="single_gallery"
                v-for="(image, imageIndex) in items"
                :key="imageIndex"
                @click="index = imageIndex"
              >
                <div class="thumb">
                  <img :src="image.src" alt="Barbershop | salon de coiffure | صالون حلاقة" />
                  <div class="image_hover">
                    <a class="popup-image">
                      <i class="ti-plus"></i>
                    </a>
                  </div>
                </div>
              </div>
            </carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import CoolLightBox from "vue-cool-lightbox";
import { db } from "./../store/firebase";
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'


export default {
  components: { carousel, CoolLightBox },

  data() {
    return {
      myOptions: {
        loop: true,
        nav: true,
        dots: false,
        margin: 30,
        items: 4,
        autoplay: true,
        navText: [
          '<i class="ti-angle-left"></i>',
          '<i class="ti-angle-right"></i>',
        ],
        autoplayHoverPause: true,
        autoplaySpeed: true,
        responsive: {
          0: {
            items: 1,
            nav: true,
          },
          767: {
            items: 2,
            nav: true,
          },
          992: {
            items: 3,
            nav: true,
          },
        },
      },
      items: [
  
        
      ],
      photos:[],
      index: null,
     isLoading:false
    };
  },
  methods: {
    setIndex(index) {
      this.index = index;
    },
  },
  created() {
    this.isLoading=true;
    db.collection("barbersImage")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
         if(doc.data().src !== undefined){
          this.items.push(doc.data());
          this.isLoading=false;

         }
        });
      });
  },
};
</script>

<style lang="scss">
@import "../styles/css/theme-default.css";
@import "../styles/css/themify-icons.css";
@import "../styles/_varriable.scss";
@import "../styles/_responsive.scss";
@import "../styles/_section_title.scss";
@import "../styles/_mixins.scss";
@import "../styles/_reset.scss";
@import "../styles/pages/_gallery.scss";
.gallery-wave{
     height: 150px;
    overflow: hidden;
    position: absolute;
    bottom: 229px;
    width: 100%;
}
</style>
